import React from 'react';
import BaseProps from "../../../types/BaseProps";
import {ResultItem, Results} from "../../../types/Search";
import ResultsTable from "./ResultsTable";
import SearchPagination from "../pagination/SearchPagination";
import SearchObjectDetails from "../object-details/SearchObjectDetails";
import {Maybe} from "../../../types/Maybe";
import {GraphQlSchema} from "../../../types/GraphQlSchema";

type SearchResultsProps = BaseProps & {
  data: Results;
  // items count per page
  pageSize: number;
  // Currently active/selected page
  currentPage: number;
  // handler for page change event
  onPage: (page: number) => void;
  disabled: boolean;
  // GraphQl schema based on the SOaaS Service GQL schema introspection
  graphQlSchema?: GraphQlSchema;
};

type SearchResultsState = {
  selectedObject: Maybe<ResultItem>;
  isDetailsOpened: boolean;
};

/**
 * Component composing search results with pager, count, etc.
 */
class SearchResults extends React.Component<SearchResultsProps, SearchResultsState> {

  constructor(props: any) {
    super(props);
    this.state = {
      selectedObject: undefined,
      isDetailsOpened: false
    }
  }

  /**
   * Handles selection of search result item.
   * @param {ResultItem} item
   */
  onResultItemSelected = (item: ResultItem) => {
    this.setState({
      selectedObject: item,
      isDetailsOpened: true
    })
  };

  /**
   * Handles closing of the object details panel.
   */
  onDetailsClosed = () => {
    this.setState({
      selectedObject: undefined,
      isDetailsOpened: false
    })
  };

  render() {
    const data: Results = this.props.data;
    const results = data.resultItems || [];

    return <>
      {
        results.length ?
          <div className="SearchResults">
            <ResultsTable data={this.props.data} onResultItemSelected={this.onResultItemSelected}/>
            <SearchPagination total={this.props.data.total}
                              currentPage={this.props.currentPage}
                              pageSize={this.props.pageSize}
                              onPage={this.props.onPage}
                              disabled={this.props.disabled}/>
          </div>
          : null
      }
      {
        this.state.isDetailsOpened && this.state.selectedObject ?
          <SearchObjectDetails selectedObject={this.state.selectedObject}
                               onClose={this.onDetailsClosed}/>
          : null
      }
    </>
  }
}

export default SearchResults;
